import React, {useState,useEffect} from 'react'
import { allProds } from 'network/ApiAxiosMerchShop';
import ProdCard from './ProdCard';
import { Row, Col, Container} from "reactstrap";
import ShopCart from './ShopCart';
import BarCodeScanner from './BarCodeScanner';
import BarCodeScannerCamera from './BarCodeScannerCamera';

function SimpleShop() {
    const [prods, setProds] = useState('');

    useEffect(() => {
        getProds()
    }, []);

    const [trigger, setTrigger] = useState(false);

    const getProds = async()=>{
        const resp = await allProds()
        setProds(resp.data)
    }

    const updateCart = ()=>{
        setTrigger(!trigger)
        
    }
  return (
    <div className='pt-8 mr-4 ml-4'>
      
      <BarCodeScannerCamera updateCartQT={updateCart}/>
    <br/>
    <ShopCart updateCartQT={trigger} refreshCart={updateCart}/>
    </div>
  )
}

export default SimpleShop